import React from 'react';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { Stack } from '@mui/system';
import { Skeleton, useMediaQuery } from '@mui/material';
import styles from './styles';

const ActionModalTitleDescription = props => {
  // const titleRef = React.useRef(null);

  // const titleRef = React.useRef(null);

  // useEffect(() => {
  //   if (!props.load && props.title && titleRef.current) {
  //     // Tiny delay improves reliability on iOS/VoiceOver and some SRs
  //     const t = setTimeout(() => titleRef.current?.focus(), 10);
  //     return () => clearTimeout(t);
  //   }
  // }, [props.load, props.title]);

  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <>
      {!props.load && props.title && props.title.search('a month') >= 0 && sm ? (
        <>
          <Typography
            variant='h2'
            component='h2'
            id={props.titleId}
            aria-hidden='true'
            sx={styles(theme).modalheaderstyle}
          >
            {`${props.title.replace('a month', '')}`}
          </Typography>
          <Typography
            variant='h2'
            sx={{ ...styles(theme).modalheaderstyle, ...styles(theme).aMonthStyle }}
          >
            a month
          </Typography>
        </>
      ) : (
        <Typography
          variant='h2'
          component='h2'
          id={props.titleId}
          aria-hidden='true'
          sx={{
            ...styles(theme).modalheaderstyle,
            outline: 'none !important',
          }}
        >
          {props.title}
        </Typography>
      )}
      {!props.load && props.description && (
        <Typography
          id={props.descriptionId}
          variant='body1'
          component='div'
          sx={{
            ...styles(theme).textstyle,
          }}
        >
          {typeof props.description !== 'object' ? (
            <span
              dangerouslySetInnerHTML={{
                __html: props.description,
              }}
            />
          ) : (
            <span> {props.description} </span>
          )}
        </Typography>
      )}
      {props.load && (
        <Stack sx={{ width: '100%' }}>
          <Skeleton
            height={20}
            width='70%'
            sx={{
              marginX: 'auto',
              marginTop: '2rem',
              marginBottom: '40px',
              backgroundColor: theme.palette.primary.contrastText,
            }}
          />
          <Skeleton
            height={20}
            width='80%'
            sx={{
              marginX: 'auto',
              marginBottom: '24px',
              backgroundColor: theme.palette.primary.contrastText,
            }}
          />
        </Stack>
      )}
    </>
  );
};

export default ActionModalTitleDescription;
